import { ISaveAnswer } from '@/contracts/modules/education/use-case/ISaveAnswer'
import { IAnswerRecord } from '@/contracts/modules/education/entities/IAnswerRecord'
import { SaveAnswerRoute } from '@/modules/education/v1/api/v1/packs/SaveAnswer/SaveAnswerRoute'
import { SaveAnswerParams } from '@/modules/education/v1/api/v1/packs/Dto/SaveAnswerParams'

export class SaveAnswer implements ISaveAnswer {
  async exec(pack: string, question: string, result: boolean, ms: number): Promise<IAnswerRecord> {
    const response = await new SaveAnswerRoute(pack).exec(new SaveAnswerParams({ question, result, ms }))
    if (!response.isSuccess()) {
      throw new Error(response.getError())
    }
    return response.getData()
  }
}
